import {
  CREATE_BANK_KOMPOS_SUCCESS,
  RETRIEVE_BANK_KOMPOS_SUCCESS,
  UPDATE_BANK_KOMPOS_SUCCESS,
  DELETE_BANK_KOMPOS_SUCCESS,
  DELETE_ALL_BANK_KOMPOS,
} from "../actions/types";

const initialState = {
  items: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 0,
};

function bankKomposReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_BANK_KOMPOS_SUCCESS:
      return { ...state, items: [...state.items, payload] };

    case RETRIEVE_BANK_KOMPOS_SUCCESS:
      return {
        ...state,
        items: payload.items,
        totalItems: payload.totalItems,
        totalPages: payload.totalPages,
        currentPage: payload.currentPage,
      };

    case UPDATE_BANK_KOMPOS_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) => {
          if (item.uuid === payload.uuid) {
            return {
              ...item,
              ...payload,
            };
          } else {
            return item;
          }
        }),
      };

    case DELETE_BANK_KOMPOS_SUCCESS:
      return {
        ...state,
        items: state.items.filter(({ uuid }) => uuid !== payload.uuid),
      };

    case DELETE_ALL_BANK_KOMPOS:
      return { ...state, items: [] };

    default:
      return state;
  }
}

export default bankKomposReducer;
